import { LitElement, css, html } from 'lit'
import { customElement } from 'lit/decorators.js'

@customElement('ep-text-form-label')
export class EPTextFormLabel extends LitElement {

  render() {
    return html`
      <label>
        <slot part="label"></slot>
      </label>
    `
  }

  static styles = css`
    :host {
      --font-prose: ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji";
      --color-fg-muted: #656d76;
      font-family: var(--font-prose);
      display: inline-block;
      line-height: 1.3;
      margin: 5px 0;
    }

    * {
      box-sizing: border-box;
    }

    label {
      padding: 0 5px;
      vertical-align: middle;
      /* min-height: 25px; */
      gap: 3px;
      font-size: 14px;
      font-weight: 600;
      line-height: 1.5;
    }
  `
}

declare global {
  interface HTMLElementTagNameMap {
    'ep-text-form-label': EPTextFormLabel
  }
}
